import { ApiClient } from './ApiClient';
import { FlightInfoService, FlightListService, WeatherService, } from './Services';
export class Dap {
    /**
     * constructor
     * @param apiKey
     * @param baseUrl Prefix for API requests.
     */
    constructor(apiKey, baseUrl) {
        /**
         * Instance of the Client class.
         */
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.client = new ApiClient({
            baseURL: baseUrl,
            headers: {
                'Api-Key': apiKey,
                'Content-Type': 'application/json',
            },
        });
    }
    /**
     * Get a single flight by its identifier.
     */
    flight() {
        return new FlightInfoService(this.client);
    }
    /**
     * Get all flights for a specified date.
     */
    flights() {
        return new FlightListService(this.client);
    }
    /**
     * Get all flights for a specified date.
     */
    weather() {
        return new WeatherService(this.client);
    }
}
//# sourceMappingURL=Dap.js.map